import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HrWidgetPageTitleComponent} from "./hr-widget-page-title.component";


@NgModule({
    declarations: [HrWidgetPageTitleComponent],
    imports: [
        CommonModule,
    ],
    exports: [HrWidgetPageTitleComponent]
})
export class HrWidgetPageTitleModule {
}
